import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { Modal } from 'components';
import { ItemInput } from 'features';
import * as actionCreators from 'store/actions';

const Container = styled.div`
    width: 50vw;
    max-width: 40rem;
    @media (max-width: 800px) {
        width: 80vw;
    }
`

const ItemInputModal = props => {
    const {} = props;
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(actionCreators.setModal(null,null))
    }

    return (
        <Modal x='50%' y='20%'>
            <Container><ItemInput type='Modal' id='ItemInputModal' parents={[]} styles={'secondary'}/></Container>
        </Modal>
    )
}

export default ItemInputModal